import OrganisationScene from '../../portal/organisation/users/scenes/OrganisationScene';
import CommunityScene from '../../portal/community/CommunityScene';
import organisationsRoutes from '../../mgmt/organisations/routes';
import communitiesRoutes from '../../mgmt/communities/routes';
import organisationRolesRoutes from '../../mgmt/organisationRoles/routes';
import identificationCodeTypesRoutes from '../../mgmt/identitficationCodeTypes/routes';
import relationTypesRoutes from '../../mgmt/relationTypes/routes';
import appsRoutes from '../../mgmt/apps/routes';
import themeLookupRoutes from '../../mgmt/themeLookups/routes';
import identitiesRoutes from '../../mgmt/identities/routes';
import Overview from '../../portal/home/components/Overview';
import principalRoutes from '../../mgmt/principals/routes';

const routes = [
  {
    title: 'Charts',
    icon: 'home',
    id: 'default',
    routes: [
      {
        path: '/overview',
        component: Overview,
        exact: true,
        menuName: 'home',
        menuIcon: 'home',
        isActiveRoute: currentLocation => currentLocation.toLowerCase().startsWith('/overview'),
      },
      {
        path: '/organisation/*',
        component: OrganisationScene,
        exact: false,
        menuName: 'myOrganisation',
      },
      {
        path: '/community/*',
        menuName: 'myCommunity',
        exact: false,
        component: CommunityScene,
        hasRight: 'COMMUNITYMEMBERS.MANAGE.COMMUNITY',
      },
      {
        path: '/mgmt',
        menuName: 'management',
        hasFeature: 'PLATFORMMGMT',
        routes: [
          ...principalRoutes,
          ...identitiesRoutes,
          ...organisationsRoutes,
          ...organisationRolesRoutes,
          ...communitiesRoutes,
          ...identificationCodeTypesRoutes,
          ...relationTypesRoutes,
          ...themeLookupRoutes,
          ...appsRoutes,
        ],
      },
    ],
  },
];

export default routes;
